// extracted by mini-css-extract-plugin
export default {"btnReset":"button_btnReset__I9Dhe"};